var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c("img", {
      staticClass: "imgCenter",
      attrs: { src: require("assets/pcTitle1.png"), alt: "" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "block1" }, [
        _c("div", { staticClass: "itemBox" }, [
          _c("div", { staticClass: "titleBox" }, [
            _c("div", { staticClass: "titleWord" }, [
              _vm._v(_vm._s(_vm.areaUserList[0].name))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alBox" }, [
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("重新犯罪")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v("\n              " + _vm._s(_vm.areaUserList[0].cxfz)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("收监")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[0].sj)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("警告")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[0].jg)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("训诫")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[0].xj)),
                _c("span", [_vm._v("人")])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "itemBox" }, [
          _c("div", { staticClass: "titleBox" }, [
            _c("div", { staticClass: "titleWord" }, [
              _vm._v(_vm._s(_vm.areaUserList[1].name))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alBox" }, [
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("重新犯罪")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v("\n              " + _vm._s(_vm.areaUserList[1].cxfz)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("收监")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[1].sj)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("警告")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[1].jg)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("训诫")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[1].xj)),
                _c("span", [_vm._v("人")])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "itemBox" }, [
          _c("div", { staticClass: "titleBox" }, [
            _c("div", { staticClass: "titleWord" }, [
              _vm._v(_vm._s(_vm.areaUserList[2].name))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alBox" }, [
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("重新犯罪")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v("\n              " + _vm._s(_vm.areaUserList[2].cxfz)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("收监")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[2].sj)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("警告")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[2].jg)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("训诫")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[2].xj)),
                _c("span", [_vm._v("人")])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block2" }, [
        _c("div", { staticClass: "itemBox" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "canvasBox" }, [
            _c("img", { attrs: { src: require("assets/ditu.png"), alt: "" } }),
            _vm._v(" "),
            _c("div", { staticClass: "fanzui" }, [
              _c("div", { staticClass: "fanzuiTitle" }, [
                _vm._v("联防联控人员")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "fanzuiline" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "swiper",
                      rawName: "v-swiper:mySwiper",
                      value: _vm.swiperOption,
                      expression: "swiperOption",
                      arg: "mySwiper"
                    }
                  ]
                },
                [
                  _c(
                    "div",
                    { staticClass: "swiper-wrapper" },
                    _vm._l(_vm.mapUserList, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "swiper-slide mapUserBox" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(item.name) +
                              _vm._s(item.text) +
                              "\n                "
                          )
                        ]
                      )
                    })
                  )
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "itemBox" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "colorBox" }, [
            _c("div", { staticClass: "colorItem" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "colorBottom" }, [
                _vm._v(_vm._s(_vm.fourUserList.four))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "colorItem" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "colorBottom" }, [
                _vm._v(_vm._s(_vm.fourUserList.three))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "colorItem" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "colorBottom" }, [
                _vm._v(_vm._s(_vm.fourUserList.two))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "colorItem" }, [
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "colorBottom" }, [
                _vm._v(_vm._s(_vm.fourUserList.one))
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block3" }, [
        _c("div", { staticClass: "itemBox" }, [
          _c("div", { staticClass: "titleBox" }, [
            _c("div", { staticClass: "titleWord" }, [
              _vm._v(_vm._s(_vm.areaUserList[3].name))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alBox" }, [
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("重新犯罪")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v("\n              " + _vm._s(_vm.areaUserList[3].cxfz)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("收监")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[3].sj)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("警告")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[3].jg)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("训诫")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[3].xj)),
                _c("span", [_vm._v("人")])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "itemBox" }, [
          _c("div", { staticClass: "titleBox" }, [
            _c("div", { staticClass: "titleWord" }, [
              _vm._v(_vm._s(_vm.areaUserList[4].name))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alBox" }, [
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("重新犯罪")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v("\n              " + _vm._s(_vm.areaUserList[4].cxfz)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("收监")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[4].sj)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("警告")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[4].jg)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("训诫")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[4].xj)),
                _c("span", [_vm._v("人")])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "itemBox" }, [
          _c("div", { staticClass: "titleBox" }, [
            _c("div", { staticClass: "titleWord" }, [
              _vm._v(_vm._s(_vm.areaUserList[5].name))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alBox" }, [
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("重新犯罪")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v("\n              " + _vm._s(_vm.areaUserList[5].cxfz)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("收监")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[5].sj)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("警告")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[5].jg)),
                _c("span", [_vm._v("人")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alItem" }, [
              _c("div", { staticClass: "alName" }, [_vm._v("训诫")]),
              _vm._v(" "),
              _c("div", { staticClass: "alValue" }, [
                _vm._v(_vm._s(_vm.areaUserList[5].xj)),
                _c("span", [_vm._v("人")])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _c("div", { staticClass: "titleWord" }, [_vm._v("联防联控")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _c("div", { staticClass: "titleWord" }, [_vm._v("四色预警")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "colorTop" }, [
      _c("img", {
        staticClass: "img1",
        attrs: { src: require("assets/yanzhong.png"), alt: "" }
      }),
      _vm._v("\n              严重\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "colorTop c2" }, [
      _c("img", {
        staticClass: "img2",
        attrs: { src: require("assets/zhongdu.png"), alt: "" }
      }),
      _vm._v("\n              中度\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "colorTop c3" }, [
      _c("img", {
        staticClass: "img3",
        attrs: { src: require("assets/qingdu.png"), alt: "" }
      }),
      _vm._v("\n              轻度\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "colorTop c4" }, [
      _c("img", {
        staticClass: "img4",
        attrs: { src: require("assets/zhengchang.png"), alt: "" }
      }),
      _vm._v("\n              正常\n            ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e1b67b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e1b67b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/pcData1.vue
// module id = null
// module chunks = 